// 'There are places where variable names are not descriptive enough. For example, the variable name "condition" is not descriptive enough. It is better to use "step" or "conditionNumber" instead.'
// 'In such cases I have tried to leave a comment explaining the reason for the change. But I might have missed some cases. Please review the code and provide feedback if you find any issues.'

import { TFlowOverrideType } from '../../Components/Calculations/constants';
import { IRelativeCondition } from '../../Components/DataSet/types/BottomBarInterfaces';
import { TFilterType, TWindowFn } from '../../types/types';
import {
  ICalculationSession,
  ICalculationStep,
  ICurrentCalculationSession,
  IFlowOverrideField,
  IOverrideFilterInfo,
  IOverrideFilterPanel,
} from './CurrentCalculationSessionInterface';

export const addNewCalculationSession = (
  propKey: string,
  calculationName: string,
  datasetId: string,
) => {
  // 'Before adding a new calculation session, check if it already exists, If it does, do not add it instead, return error'
  // 'above is a pending task'

  return {
    type: 'ADD_NEW_CALCULATION_SESSION',
    payload: {
      propKey,
      calculationName,
      datasetId,
    },
  };
};

export const addInitialCalculationFlow = (
  propKey: string,
  calculationFlow: { uid: string; flow: string; isAggregation: boolean },
  conditionUid: string,
  flowDisplayName?: string,
) => {
  return {
    type: 'ADD_INITIAL_CALCULATION_FLOW',
    payload: {
      propKey,
      calculationFlow,
      conditionUid,
      flowDisplayName,
    },
  };
};
export const addConditionForIfElse = (
  propKey: string,
  calculationFlow: { uid: string; flow: string },
  conditionUid: string,
  conditionType: string,
  activeConditionId: number,
) => {
  return {
    type: 'ADD_CONDITION_FOR_IF_ELSE',
    payload: {
      propKey,
      calculationFlow,
      conditionUid,
      conditionType,
      activeConditionId,
    },
  };
};

export const addResultantDatatypeInCalculationFlow = (
  calculationFlow: { uid: string; flow: string },
  propKey: string,
  resultantDatatype: string,
  conditionNumber: number,
) => {
  return {
    type: 'UPDATE_RESULTANT_DATATYPE',
    payload: {
      calculationFlow,
      propKey,
      resultantDatatype,
      conditionNumber,
    },
  };
};

export const addSourceInfoInCalculationFlow = (
  sourceId: string | number,
  calculationFlow: { uid: string; flow: string },
  propKey: string,
  dataType: string,
  isAggregation: boolean,
  aggregation: string | null,
  conditionNumber: number,
) => {
  return {
    type: 'ADD_SOURCE_INFO_IN_CALCULATION_FLOW',
    payload: {
      sourceId,
      calculationFlow,
      propKey,
      dataType,
      isAggregation,
      aggregation,
      conditionNumber,
    },
  };
};

export const addCalculationField = (
  propKey: string,
  calculationFieldUID: string,
  calculationField: {
    tableId: string;
    fieldName: string;
    displayName: string;
    dataType: string;
  },
) => {
  return {
    type: 'ADD_CALCULATION_FIELD',
    payload: {
      propKey,
      calculationFieldUID,
      calculationField,
    },
  };
};

export const saveNewCalculation = (
  propKey: string,
  uuid: string,
  isAggregated: boolean,
  datatype: string,
  orderedListOfFlows : string[],
) => {
  return {
    type: 'SAVE_CALCULATION',
    payload: {
      uuid,
      propKey,
      isAggregated,
      datatype,
      orderedListOfFlows
    },
  };
};

export const resetFetchRowLevelCalc = () => {
  return { type: 'RESET_FETCH_ROW_LEVEL_CALCULATIONS' };
};

export const setFlowPositions = (
  propKey: string,
  calculationFlowUID: string,
  x: string,
  y: string,
) => {
  return {
    type: 'SET_FLOW_POSITIONS',
    payload: {
      propKey,
      calculationFlowUID,
      x,
      y,
    },
  };
};

export const setIsAggregated = (
  propKey: string,
  step: number | null,
  calculationFlowUID: string,
  isAggregated: boolean,
) => {
  return {
    type: 'SET_IS_AGGREGATED',
    payload: {
      propKey,
      calculationFlowUID,
      isAggregated,
      step,
    },
  };
};

export const setActiveFlow = (propKey: string, calculationFlowUID: string | null) => {
  return {
    type: 'SET_ACTIVE_FLOW',
    payload: {
      propKey,
      calculationFlowUID,
    },
  };
};

export const deleteFlow = (propKey: string, flowUID: string) => {
  return {
    type: 'DELETE_FLOW',
    payload: {
      propKey,
      flowUID,
    },
  };
};

export const deleteSourceFromFlow = (
  calculationFlowUID: string,
  sourceUID: string,
  propKey: string,
  sourceIndex: number,
) => {
  // This variable name suggests that it deletes the source only from flow but it actually deletes the source from flow, source and condition filter too.
  // have not changed the variable name not to break the existing code

  return {
    type: 'DELETE_SOURCE',
    payload: {
      calculationFlowUID,
      sourceUID,
      propKey,
      sourceIndex,
    },
  };
};

export const deleteSourceFromFlowWithoutIndexing = (
  calculationFlowUID: string,
  sourceUID: string,
  propKey: string,
  sourceIndex: number,
) => {
  // This variable name suggests that it deletes the source only from flow but it actually deletes the source from flow, source and condition filter too.
  // have not changed the variable name not to break the existing code

  return {
    type: 'DELETE_SOURCE_WITHOUT_INDEX_SHIFTING',
    payload: {
      calculationFlowUID,
      sourceUID,
      propKey,
      sourceIndex,
    },
  };
};
/***
 *
 * @param {string}  calculationFlowUID (Required)
 * @param {string}  propKey (Required)
 * @param {number} filterIdx (Required)
 */
export const deleteSourceV2 = (
  calculationFlowUID: string,
  sourceUID: string,
  propKey: string,
  sourceIndex: number,
  filterIdx: number,
) => {
  return {
    type: 'DELETE_SOURCE_V2',
    payload: {
      calculationFlowUID,
      sourceUID,
      propKey,
      sourceIndex,
      filterIdx,
    },
  };
};
export const moveSourceCard = (
  dragIndex: number,
  hoverIndex: number,
  propKey: string,
  calculationFlowUID: string,
  step: number,
) => {
  return {
    type: 'MOVE_SOURCE_CARD',
    payload: {
      dragIndex,
      hoverIndex,
      propKey,
      calculationFlowUID,
      step,
    },
  };
};

export const updateSourceAggregation = (
  propKey: string,
  calculationFlowUID: string,
  step: number,
  sourceIndex: number,
  newAggregation: string,
) => {
  return {
    type: 'UPDATE_SOURCE_AGGREGATION',
    payload: {
      propKey,
      calculationFlowUID,
      step,
      sourceIndex,
      newAggregation,
    },
  };
};

export const updateFlowPositions = (
  propKey: string,
  calculationFlowUID: string,
  x: string,
  y: string,
) => {
  return {
    type: 'UPDATE_FLOW_POSITIONS',
    payload: {
      propKey,
      calculationFlowUID,
      x,
      y,
    },
  };
};

export const addConditionFilter = (propKey: string, conditionFilter: any) => {
  return {
    type: 'ADD_CONDITION_FILTER',
    payload: {
      propKey,
      conditionFilter,
    },
  };
};

export const updateSearchConditionFilter = (
  propKey: string,
  conditionFilterUid: string,
  sourceUid: string,
  shouldExclude: boolean,
) => {
  return {
    type: 'UPDATE_SEARCH_CONDITION_FILTER',
    payload: {
      propKey,
      conditionFilterUid,
      sourceUid,
      shouldExclude,
    },
  };
};
export const updateConditionFilter = (
  propKey: string,
  conditionFilterUid: string,
  sourceUid: string,
  conditionFilter: {
    filterType: string;
    rightOperand: (string | number | null)[];
    rightOperandType: string[];
    operator: string;
    shouldExclude: boolean;
    isTillDate: boolean;
    timeGrain: string;
    relativeCondition: IRelativeCondition | null;
  },
  filterIdx: number,
) => {
  return {
    type: 'UPDATE_CONDITION_FILTER',
    payload: {
      propKey,
      conditionFilterUid,
      sourceUid,
      conditionFilter,
      filterIdx,
    },
  };
};
export const updateFilterOperator = (
  propKey: string,
  conditionFilterUid: string,
  operandIdx: number,
  operator: string,
) => {
  return {
    type: 'UPDATE_FILTER_OPERATOR',
    payload: {
      propKey,
      conditionFilterUid,
      operandIdx,
      operator,
    },
  };
};

export const updateTimeGrain = (
  propKey: string,
  conditionFilterUid: string,
  filterIdx: number,
  timeGrain: string,
) => {
  return {
    type: 'UPDATE_TIMEGRAIN',
    payload: {
      propKey,
      conditionFilterUid,
      filterIdx,
      timeGrain,
    },
  };
};

export const toggleIsTillDate = (
  propKey: string,
  conditionFilterUid: string,
  sourceIndex: number,
) => {
  return {
    type: 'TOGGLE_IS_TILL_DATE',
    payload: {
      propKey,
      conditionFilterUid,
      sourceIndex,
    },
  };
};

export const updateActiveConditionId = (propKey: string, activeConditionId: number) => {
  return {
    type: 'UPDATE_ACTIVE_CONDITION_ID',
    payload: {
      propKey,
      activeConditionId,
    },
  };
};
export const updateFlowCondition = (
  propKey: string,
  calculationFlowUID: string,
  conditionIndex: number,
  condition: string,
) => {
  return {
    type: 'UPDATE_FLOW_CONDITION',
    payload: {
      propKey,
      calculationFlowUID,
      conditionIndex,
      condition,
    },
  };
};
export const updateConditionName = (
  propKey: string,
  flowId: string,
  conditionUid: string,
  conditionName: string,
) => {
  return {
    type: 'UPDATE_CONDITION_NAME',
    payload: {
      propKey,
      conditionUid,
      conditionName,
      flowId,
    },
  };
};
export const deleteConditionFromIfElse = (
  propKey: string,
  flowId: string,
  conditionUid: string,
) => {
  return {
    type: 'DELETE_CONDITION_FROM_IF_ELSE',
    payload: {
      propKey,
      flowId,
      conditionUid,
    },
  };
};
export const deleteConditionFilter = (propKey: string, conditionFilterUid: string) => {
  return {
    type: 'DELETE_CONDITION_FILTER',
    payload: {
      propKey,
      conditionFilterUid,
    },
  };
};
export const sortConditionInIfElse = (
  propKey: string,
  flowId: string,
  dragConditionUid: string,
  dropConditionUid: string,
) => {
  return {
    type: 'SORT_CONDITION_IN_IF_ELSE',
    payload: {
      propKey,
      flowId,
      dragConditionUid,
      dropConditionUid,
    },
  };
};
export const revert = (propKey: string, flowId: string, conditionList: ICalculationStep[]) => {
  return {
    type: 'REVERT',
    payload: {
      propKey,
      flowId,
      conditionList,
    },
  };
};
export const updateConditionTypeFlow = (propKey: string, flowId: string) => {
  return {
    type: 'CORRECT_CONDITION_TYPE_FLOW',
    payload: {
      propKey,
      flowId,
    },
  };
};

export const updateDecimalSourceValue = (propKey: string, sourceIndex: number, value: number) => {
  return {
    type: 'UPDATE_DECIMAL_SOURCE_VALUE',
    payload: {
      propKey,
      sourceIndex,
      value,
    },
  };
};

export const updateFlowDisplayName = (propKey: string, flowUID: string, displayName: string) => {
  return {
    type: 'UPDATE_FLOW_DISPLAY_NAME',
    payload: {
      propKey,
      flowUID,
      displayName,
    },
  };
};

export const updateCalculationName = (propKey: string, calculationName: string) => {
  return {
    type: 'UPDATE_CALCULATION_NAME',
    payload: {
      propKey,
      calculationName,
    },
  };
};

export const resetCurrentCalculationSession = (propKey: string) => {
  return {
    type: 'RESET_CALCULATION_SESSION',
    payload: {
      propKey,
    },
  };
};

export const addResultForIfElse = (
  propKey: string,
  flowId: string,
  conditionIndex: number,
  sourceId: string,
  sourceType: string,
) => {
  return {
    type: 'ADD_RESULT_FOR_IF_ELSE',
    payload: {
      propKey,
      flowId,
      conditionIndex,
      sourceId,
      sourceType,
    },
  };
};

export const setResultTypeForIfElse = (
  propKey: string,
  flowId: string,
  resultType: string | null,
) => {
  return {
    type: 'SET_RESULT_TYPE_FOR_IF_ELSE',
    payload: {
      propKey,
      flowId,
      resultType,
    },
  };
};
export const resetResultForIfElse = (propKey: string, flowId: string, conditionIndex: number) => {
  return {
    type: 'RESET_RESULT_FOR_IF_ELSE',
    payload: {
      propKey,
      flowId,
      conditionIndex,
    },
  };
};

export const deleteResult = (propKey: string, flowId: string, conditionIndex: number) => {
  return {
    type: 'DELETE_RESULT_FOR_IF_ELSE',
    payload: {
      propKey,
      flowId,
      conditionIndex,
    },
  };
};

export const editSavedCalculation = (propKey: string, calculationFieldName: string) => {
  return {
    type: 'EDIT_SAVED_CALCULATION',
    payload: {
      propKey,
      calculationFieldName,
    },
  };
};

export const deleteSavedCalculation = (calculationFieldName: string, propKey: string) => {
  return {
    type: 'DELETE_SAVED_CALCULATION',
    payload: {
      calculationFieldName,
      propKey,
    },
  };
};

export const setSource = (
  propKey: string,
  flowId: string,
  subFlowId: number,
  source: any,
  sourceType: string | string[],
  sourceIndex: number,
) => {
  return {
    type: 'SET_SOURCE',
    payload: {
      propKey,
      flowId,
      subFlowId,
      source,
      sourceType,
      sourceIndex,
    },
  };
};
export const resetSource = (propKey: string, flowId: string, subFlowId: number) => {
  return {
    type: 'RESET_SOURCE',
    payload: {
      propKey,
      flowId,
      subFlowId,
    },
  };
};

/**
 *
 * @param propKey
 * @param flowId
 * @param subFlowId
 * @param source
 * @param sourceType
 * @param sourceIndex
 * @returns void
 *  if @param sourceIndex is undefined or  outside source length  then value is pushed at the end else it update the existing value
 */
export const addSource = (
  propKey: string,
  flowId: string,
  subFlowId: number,
  source: any,
  sourceType: string,
  sourceIndex?: number,
) => {
  return {
    type: 'ADD_SOURCE_WITHOUT_RESTRICTION',
    payload: {
      propKey,
      flowId,
      subFlowId,
      source,
      sourceType,
      sourceIndex,
    },
  };
};

export const deleteSourceV3 = (
  propKey: string,
  flowId: string,
  subFlowId: number,
  sourceIndex?: number,
) => {
  return {
    type: 'DELETE_SOURCE_V4',
    payload: {
      propKey,
      flowId,
      subFlowId,
      sourceIndex,
    },
  };
};
export const updateSource = (propKey: string, sourceIndex: number, newSourceValue: string) => {
  return {
    type: 'UPDATE_SOURCE',
    payload: {
      propKey,
      sourceIndex,
      newSourceValue,
    },
  };
};

export const addTableIdToCurrentCalculationSession = (tableId: string, propKey: string) => {
  return {
    type: 'ADD_TABLE_ID_TO_CURRENT_CALCULATION_SESSION',
    payload: {
      tableId,
      propKey,
    },
  };
};

export const setCalculationsState = (calculations: ICalculationSession) => {
  return {
    type: 'SET_CALCULATION_STATE',
    payload: {
      calculations,
    },
  };
};

export const insertFlowSource = (
  propKey: string,
  flowUidOfDestinationFlow: string,
  flowUidOfValueFlow: string,
) => {
  return {
    type: 'INSERT_FLOW_SOURCE',
    payload: {
      propKey,
      flowUidOfDestinationFlow,
      flowUidOfValueFlow,
    },
  };
};

export const resetCalculationState = () => {
  return { type: 'RESET_CALCULATION_STATE' };
};

export const setAggregationForFlow = (
  calculationFlowUID: string,
  isAggregation: boolean,
  propKey: string,
) => {
  return {
    type: 'SET_AGGREGATION_FOR_FLOW',
    payload: {
      calculationFlowUID,
      isAggregation,
      propKey,
    },
  };
};

export const fieldFlowRightOperand = (
  conditionFilterId: string,
  leftOperandIndex: number,
  rightOperandType: string,
  rightOperand: object,
  propKey: string,
  fieldId: string,
) => {
  return {
    type: 'FIELD_FLOW_RIGHT_OPERAND',
    payload: {
      conditionFilterId,
      leftOperandIndex,
      rightOperandType,
      rightOperand,
      propKey,
      fieldId,
    },
  };
};

export const fieldFlowRightOperandBetween = (
  conditionFilterId: string,
  leftOperandIndex: number,
  rightOperandType: string,
  rightOperand: object,
  propKey: string,
  fieldId: string,
  dropzoneFlag: string, // Add flag to differentiate dropzones
) => {
  return {
    type: 'FIELD_FLOW_RIGHT_OPERAND_BETWEEN',
    payload: {
      conditionFilterId,
      leftOperandIndex,
      rightOperandType,
      rightOperand,
      propKey,
      fieldId,
      dropzoneFlag, // Pass to reducer
    },
  };
};

export const fieldFlowshowFirst = (
  propKey: string,
  conditionFilterId: string,
  filterIdx: number,
  value: boolean,
) => {
  return {
    type: 'SET_SHOW_FIRST_FOR_CONDITION',
    payload: {
      propKey,
      conditionFilterId,
      filterIdx,
      value,
    },
  };
};

export const fieldFlowshowSecond = (
  propKey: string,
  conditionFilterId: string,
  filterIdx: number,
  value: boolean,
) => {
  return {
    type: 'SET_SHOW_SECOND_FOR_CONDITION',
    payload: {
      propKey,
      conditionFilterId,
      filterIdx,
      value,
    },
  };
};

export const deleteFieldFlowRightOperand = (
  conditionFilterId: string,
  leftOperandIndex: number,
  rightOperandType: string,
  propKey: string,
  fieldId: string,
) => {
  return {
    type: 'DELETE_FIELD_FLOW_RIGHT_OPERAND',
    payload: {
      conditionFilterId,
      leftOperandIndex,
      rightOperandType,
      propKey,
      fieldId,
    },
  };
};
export const deleteFieldFlowRightOperandBetween = (
  conditionFilterId: string,
  leftOperandIndex: number,
  rightOperandType: string,
  propKey: string,
  fieldId: string,
  dropzoneFlag: string,
) => {
  return {
    type: 'DELETE_FIELD_FLOW_RIGHT_OPERAND_BETWEEN',
    payload: {
      conditionFilterId,
      leftOperandIndex,
      rightOperandType,
      propKey,
      fieldId,
      dropzoneFlag, // Include dropzoneFlag
    },
  };
};

export const deleteRightOperandForStaticValue = (
  conditionFilterId: string,
  leftOperandIndex: number,
  propKey: string,
) => {
  return {
    type: 'DELETE_RIGHT_OPERAND_FOR_STATIC_VALUE',
    payload: {
      conditionFilterId,
      leftOperandIndex,
      propKey,
    },
  };
};
export const deleteRightOperandForStaticValueBetween = (
  conditionFilterId: string,
  leftOperandIndex: number,
  propKey: string,
  targetIndex: number,
) => {
  return {
    type: 'DELETE_RIGHT_OPERAND_FOR_STATIC_VALUE_BETWEEN',
    payload: {
      conditionFilterId,
      leftOperandIndex,
      propKey,
      targetIndex,
    },
  };
};

export const changeIsValidState = (
  propKey: string,
  filterId: string,
  conditionIndex: number,
  isValid: boolean,
) => {
  return {
    type: 'CHANGE_IS_VALID_STATE',
    payload: {
      propKey,
      filterId,
      conditionIndex,
      isValid,
    },
  };
};

export const updateCalculatedFieldName = (propKey: string, calculationFieldName: string) => {
  return {
    type: 'UPDATE_CALCULATED_FIELD_NAME',
    payload: {
      propKey,
      calculationFieldName,
    },
  };
};

export const updateDisplayFieldName = (propKey: string, displayFieldName: string) => {
  return {
    type: 'UPDATE_DISPLAY_FIELD_NAME',
    payload: {
      propKey,
      displayFieldName,
    },
  };
};

export const setFilterType = (
  propKey: string,
  filterType: TFilterType,
  operandIndex: number,
  conditionFilterId: string,
) => {
  return {
    type: 'SET_FILTER_TYPE',
    payload: {
      propKey,
      filterType,
      operandIndex,
      conditionFilterId,
    },
  };
};
export const setShouldExclude = (
  propKey: string,
  conditionFilterId: string,
  operandIndex: number,
  value: boolean,
) => {
  return {
    type: 'SET_SHOULD_EXCLUDE',
    payload: {
      propKey,
      conditionFilterId,
      operandIndex,
      value,
    },
  };
};
/**
 * if you send flow or field id it will work but wont delete or update the flow or field in  calculation info
 */
export const setRightOperand = (
  propKey: string,
  conditionFilterId: string,
  operandIndex: number,
  rightOperand: any[],
  rightOperandType: any[],
) => {
  return {
    type: 'SET_RIGHT_OPERAND',
    payload: {
      propKey,
      conditionFilterId,
      operandIndex,
      rightOperand,
      rightOperandType,
    },
  };
};
export const setRelativeCondition = (
  propKey: string,
  conditionFilterId: string,
  operandIndex: number,
  relativeCondition: IRelativeCondition,
) => {
  return {
    type: 'SET_RELATIVE_CONDITION',
    payload: {
      propKey,
      conditionFilterId,
      operandIndex,
      relativeCondition,
    },
  };
};

export const addField = (
  propKey: string,
  fieldId: string,
  fieldName: string,
  dataType: string,
  displayName: string,
  tableId: string,
) => {
  return {
    type: 'ADD_FIELD',
    payload: {
      propKey,
      fieldId,
      fieldName,
      dataType,
      displayName,
      tableId,
    },
  };
};
export const deleteField = (propKey: string, fieldId: string) => {
  return {
    type: 'DELETE_FIELD',
    payload: {
      propKey,
      fieldId,
    },
  };
};

export const updateFilterOverride = (
  propKey: string,
  filterOverrideInfo: {
    type: TFlowOverrideType;
    isFilterGroup: boolean;
    filterGroups: string[];
    filters: IFlowOverrideField[];
    filterPanel: IOverrideFilterPanel;
  },
) => {
  return {
    type: 'UPDATE_FILTER_OVERRIDE',
    payload: {
      propKey,
      filterOverrideInfo,
    },
  };
};

export const updateDimensionOverride = (
  propKey: string,
  dimensionOverrideInfo: {
    type: TFlowOverrideType;
    dimensions: IFlowOverrideField[];
  },
) => {
  return {
    type: 'UPDATE_DIMENSION_OVERRIDE',
    payload: {
      propKey,
      dimensionOverrideInfo,
    },
  };
};

export const updateFieldOfDimensionOverride = (
  propKey: string,
  field: IFlowOverrideField,
  operation: 'add' | 'rmv' | 'update' = 'add',
) => {
  return {
    type: 'UPDATE_FIELD_OF_DIMENSION_OVERRIDE',
    payload: {
      propKey,
      field,
      operation,
    },
  };
};

export const setTypeSelectionDropdown = (propKey: string, selectedType: string) => {
  return {
    type: 'UPDATE_TYPESELECTION_DROPDOWN',
    payload: {
      propKey,
      selectedType,
    },
  };
};

export const setToggleButton = (propKey: String, selectedType: boolean) => {
  return {
    type: 'UPDATE_TOGGLE_SELECTION',
    payload: {
      propKey,
      selectedType,
    },
  };
};

export const setToggleVar = (propKey: string, toggleVar: string) => {
  return {
    type: 'UPDATE_TOGGLE_VAR',
    payload: {
      propKey,
      toggleVar,
    },
  };
};

export const fieldDataType = (propKey: string, dataType: string) => {
  return {
    type: 'UPDATE_FIELD_DATA_TYPE',
    payload: {
      propKey,
      dataType,
    },
  };
};

export const setAggregationValue = (
  propKey: string,
  flowId: string,
  subFlowId = 0,
  aggregation: string,
  resultDataType?: string,
) => {
  return {
    type: 'SET_AGGREGATION_VALUE',
    payload: {
      propKey,
      flowId,
      subFlowId,
      aggregation,
      resultDataType,
    },
  };
};
export const updateIsFilterGroup = (propKey: string, value: boolean) => {
  return {
    type: 'SET_IS_FILTER_GROUP',
    payload: {
      propKey,
      value,
    },
  };
};

export const updateFilter = (
  propKey: string,
  filterId: string,
  operation: 'add' | 'update' | 'rmv',
  field?: IFlowOverrideField,
) => {
  return {
    type: 'UPDATE_FILTER_IN_OVERRIDE',
    payload: {
      propKey,
      filterId,
      operation,
      field,
    },
  };
};

export const updateFilterPanel = (
  propKey: string,
  operation: 'add' | 'rmv' | 'update',
  filterId: string,
  filterInfo?: IOverrideFilterInfo,
) => {
  return {
    type: 'UPDATE_OVERRIDE_FILTER_PANEL',
    payload: {
      propKey,
      operation,
      filterId,
      filterInfo,
    },
  };
};

/// Actions for parameter-in-formula

export const setParameterForFlow = (
  propKey: string,
  activeFlow: string,
  isFlowParameterized: boolean,
) => {
  return {
    type: 'SET_PARAMETER_FOR_FLOW',
    payload: {
      propKey,
      activeFlow,
      isFlowParameterized,
    },
  };
};

export const setParameterId = (propKey: string, parameterId: string, index: number) => {
  return {
    type: 'SET_PARAMETER_ID',
    payload: {
      propKey,
      parameterId,
      index,
    },
  };
};

export const removeParameter = (
  propKey: string,
  parameterId: string,
  calculationFlowUID: string,
) => {
  return {
    type: 'REMOVE_PARAMETER',
    payload: {
      propKey,
      parameterId,
      calculationFlowUID,
    },
  };
};

export const updateParameterCardPosition = (
  propKey: string,
  calculationFlowUID: string,
  parameterId: string,
  index: number,
) => {
  return {
    type: 'UPDATE_PARAMETER_CARD_POSITION',
    payload: {
      propKey,
      calculationFlowUID,
      parameterId,
      index,
    },
  };
};

export const updateCalculation = (calculation: ICurrentCalculationSession) => {
  return {
    type: 'UPDATE_CALCULATION',
    payload: {
      calculation,
    },
  };
};

export const setParameterRightOperand = (
  propKey: string,
  conditionFilterId: string,
  filterIdx: number,
  rightOperand: any[],
  rightOperandType: any[],
  parameterId?: string,
) => {
  return {
    type: 'SET_PARAMETER_RIGHT_OPERAND',
    payload: {
      propKey,
      conditionFilterId,
      filterIdx,
      rightOperand,
      rightOperandType,
      parameterId,
    },
  };
};

export const removeParameterRightOperand = (
  propKey: string,
  conditionFilterId: string,
  filterIdx: number,
  parameterId?: string,
) => {
  return {
    type: 'REMOVE_PARAMETER_RIGHT_OPERAND',
    payload: {
      propKey,
      conditionFilterId,
      filterIdx,
      parameterId,
    },
  };
};

export const AddOrUpdateWindowFunction = (propKey: string, flowId: string, windowFunction: TWindowFn) => {
  return {
    type: 'ADD_WINDOW_FUNCTION',
    payload: {
      propKey,
      flowId,
      windowFunction,
    },
  };
};

export const RemoveWindowFunction = (propKey: string,flowId:string) => {
  return {
    type: 'REMOVE_WINDOW_FUNCTION',
    payload: {
      propKey,
      flowId,
    },
  };
};

export const deleteSourceField = (sourceUID: string, propKey: string) => {
  return {
    type: 'DELETE_INVALID_FIELD',
    payload: {
      sourceUID,
      propKey,
    },
  };
};

export const replaceSourceInfoInCalculationFlow = (
  sourceId: string | number,
  calculationFlow: { uid: string; flow: string },
  propKey: string,
  dataType: string,
  isAggregation: boolean,
  aggregation: string | null,
  conditionNumber: number,
  replaceIndex: number,
) => {
  return {
    type: 'REPLACE_SOURCE_INFO_IN_CALCULATION_FLOW',
    payload: {
      sourceId,
      calculationFlow,
      propKey,
      dataType,
      isAggregation,
      aggregation,
      conditionNumber,
      replaceIndex,
    },
  };
};
